export function getPayloadErrorMessage(payload: any, fallbackMessage: string): string | null {
    if (!payload || payload.success !== false) {
        return null;
    }

    if (Array.isArray(payload.errors)) {
        const firstError = payload.errors.find((error: any) => error && error.message);
        if (firstError && firstError.message) {
            return firstError.message;
        }
    }

    return payload.error || fallbackMessage;
}

export type ReviewMutationOutcome =
    | { ok: true; conflict: false; error: null }
    | { ok: false; conflict: boolean; error: string };

/**
 * Classifies a review-mutation payload. Only an explicit `success: true` without a conflict is an
 * acknowledged success; a missing or empty payload is never treated as success.
 */
export function getReviewMutationOutcome(payload: any, failureMessage: string, conflictMessage: string): ReviewMutationOutcome {
    if (payload && payload.success === true && !payload.conflict) {
        return { ok: true, conflict: false, error: null };
    }

    if (payload && payload.conflict) {
        return { ok: false, conflict: true, error: payload.error || conflictMessage };
    }

    return { ok: false, conflict: false, error: getPayloadErrorMessage(payload, failureMessage) || failureMessage };
}

export function getRelayFailureMessage(error: any, fallbackMessage: string): string {
    if (error && typeof error.getError === 'function') {
        const relayError = error.getError();
        if (relayError && relayError.message) {
            return relayError.message;
        }
    }

    return (error && error.message) || fallbackMessage;
}
